<template>
    <div class="h-48 bg-gray-100 rounded-lg overflow-hidden relative">
        <div v-if="!hasCoordinates" class="h-full flex items-center justify-center">
            <p class="text-gray-400">Map Preview</p>
        </div>
        <GMapMap
            v-else
            :center="{ lat: latitude, lng: longitude }"
            :zoom="15"
            map-type-id="roadmap"
            :options="{
                disableDefaultUI: false,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                gestureHandling: 'cooperative'
            }"
            class="w-full h-full"
        >
            <GMapMarker
                :position="{ lat: latitude, lng: longitude }"
            />
        </GMapMap>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    latitude: {
        type: Number,
        default: null
    },
    longitude: {
        type: Number,
        default: null
    }
})

const hasCoordinates = computed(() => {
    return props.latitude !== null && props.longitude !== null && 
           !isNaN(props.latitude) && !isNaN(props.longitude)
})
</script>
